import * as tslib_1 from "tslib";
import datapoints from '../datapoints';
import { observer } from 'mobx-react';
import { ActionButton } from 'office-ui-fabric-react/lib/Button';
import { Check } from 'office-ui-fabric-react/lib/components/Check';
import { toggleSelectAllRows } from 'owa-mail-actions';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { logUsage } from 'owa-analytics';
import { logMountingPerformance } from 'owa-analytics';
import { addFavoritePersona, lazyRemoveFavoritePersona, lazyHandleToggleFavoritePersonaError, } from 'owa-mail-favorites-store';
import { ToggleFavoriteButton, getIsBitEnabled } from 'owa-favorites';
import { favoritesStore, isPersonaInFavorites } from 'owa-favorites';
import MailListFilter from 'owa-mail-list-filter-view/lib/components/MailListFilter';
import getSelectedTableView from 'owa-mail-list-store/lib/utils/getSelectedTableView';
import { datapoints as messageDatapoints, lazyNewMessage } from 'owa-mail-message-actions';
import PersonaHeaderFirstRun from './PersonaHeaderFirstRun';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import { default as rcStore } from 'owa-recipient-cache/lib/store/store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import strings from 'owa-strings/owa-people-strings';
import * as React from 'react';
import { personaCardBehavior, } from 'owa-persona/lib/components/PersonaCardBehavior';
import getFavoritePersona from 'owa-mail-favorites-store/lib/selectors/getFavoritePersona';
import { isFavoritingInProgress } from 'owa-mail-favorites-store';
var viewFiltersForMailFolderNode = ['All', 'Unread', 'ToOrCcMe', 'Flagged'];
var styles = require('./PersonaHeader.scss');
var classNames = require('classnames/bind').bind(styles);
var PersonaHeader = /** @class */ (function (_super) {
    tslib_1.__extends(PersonaHeader, _super);
    function PersonaHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderCheckAll = function (tableView) {
            // PersonaHeader could be loaded independent of list view in PhotoHub,
            // so we need to check if tableView is null
            var isInCheckedMode = tableView && tableView.isInCheckedMode;
            var isListViewEmpty = tableView && tableView.rowKeys.length == 0;
            var isReadingPanePositionRight = getUserConfiguration().UserOptions.GlobalReadingPanePositionReact ==
                ReadingPanePosition.Right;
            var checkBoxClassNames = classNames(isReadingPanePositionRight ? styles.checkBoxThreeColumn : styles.checkBoxSingleLine, isInCheckedMode && styles.showCheckbox, !isListViewEmpty && styles.listViewHasItems);
            return (React.createElement("div", { className: checkBoxClassNames, onClick: isListViewEmpty ? null : function () { return toggleSelectAllRows(tableView); } }, React.createElement(Check, { checked: isInCheckedMode })));
        };
        _this.handleEmailClick = function (ev) {
            logUsage(messageDatapoints.MailComposeFromHeader.datapoint.name);
            if (_this.props.composeEmailClick) {
                _this.props.composeEmailClick();
            }
            else {
                lazyNewMessage.importAndExecute('PersonaHeader', null /*groupId*/, _this.props.personEmail, _this.props.personName, true);
            }
        };
        _this.toggleFavoriteState = function (evt) {
            var isInProgress = isFavoritingInProgress(_this.props.personEmail);
            if (isInProgress) {
                // Don't allow click if favoriting is in progress
                return;
            }
            evt.stopPropagation();
            var isPersonFavorite = isPersonaInFavorites(_this.props.personaId, _this.props.personEmail);
            var togglingPromise;
            if (!isPersonFavorite) {
                togglingPromise = addFavoritePersona(_this.props.personaId, _this.props.personEmail, _this.props.personName, _this.props.favoriteActionSource);
            }
            else {
                var favoriteNode = getFavoritePersona(_this.props.personaId, _this.props.personEmail);
                togglingPromise = lazyRemoveFavoritePersona.importAndExecute(favoriteNode.id, _this.props.favoriteActionSource);
            }
            togglingPromise.catch(function (e) { return lazyHandleToggleFavoritePersonaError.importAndExecute(e); });
        };
        return _this;
    }
    PersonaHeader.prototype.render = function () {
        var _this = this;
        var personEmail = this.props.personEmail;
        var titleText = this.props.personNameDisplayOverride || this.props.personName;
        var isPersonFavorite = isPersonaInFavorites(this.props.personaId, personEmail);
        var tableView = getSelectedTableView();
        return (React.createElement("div", { className: styles.headerContainer },
            React.createElement("div", { className: styles.imageAndInfoContainer },
                this.wrapInLPCTarget(React.createElement(PersonaControl, { emailAddress: this.props.personEmail, name: this.props.personName, size: PersonaSize.regular })),
                React.createElement("div", { className: styles.personInfoContainer },
                    React.createElement("div", { className: styles.firstLine },
                        this.wrapInLPCTarget(React.createElement("div", { className: styles.personName }, titleText), true),
                        React.createElement("div", { className: styles.favoriteContainer, ref: function (ref) { return (_this.toggleFavoriteDiv = ref); } },
                            React.createElement(ToggleFavoriteButton, { isInFavorites: isPersonFavorite, buttonStyles: styles.favoriteButton, iconStyles: styles.favoriteIcon, onClick: this.toggleFavoriteState, animate: true }))),
                    this.wrapInLPCTarget(React.createElement("div", { className: styles.personEmail }, this.props.personEmail), true))),
            this.getHeaderButtons(tableView, isPersonFavorite),
            this.showPersonaHeaderFirstRunExperience()));
    };
    PersonaHeader.prototype.componentDidMount = function () {
        this.logHeaderRendered();
    };
    PersonaHeader.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.personaId !== prevProps.personaId ||
            this.props.favoriteActionSource !== prevProps.favoriteActionSource) {
            this.logHeaderRendered();
        }
    };
    PersonaHeader.prototype.wrapInLPCTarget = function (children, isHiddenOverflow) {
        if (isHiddenOverflow === void 0) { isHiddenOverflow = false; }
        return (React.createElement(LPCWrapper, { disableHoverAndKeyPress: true, emailAddress: this.props.personEmail, name: this.props.personName, composeEmailOverride: this.props.composeEmailClick, personaType: 'User', className: isHiddenOverflow ? styles.hiddenOverflow : undefined }, children));
    };
    PersonaHeader.prototype.shouldShowPersonaHeaderFirstRun = function () {
        if (!rcStore.recipientCache) {
            return false;
        }
        // Show the persona header first run experience only once
        if (getIsBitEnabled(4 /* PersonaHeaderFirstRunSeen */)) {
            return false;
        }
        // If the header was displayed from the search
        if (this.props.favoriteActionSource !== 'PersonaHeaderFromFolderSearch' &&
            this.props.favoriteActionSource !== 'PersonaHeaderFromPersonaSearch') {
            return false;
        }
        // If the user doesn't have any persona favorites
        if (favoritesStore.favoritesPersonaNodes.size > 0) {
            return false;
        }
        if (!this.props.personEmail) {
            return false;
        }
        var personEmailLowerCase = this.props.personEmail.toLowerCase();
        // If the displayed persona is within the top 100 people returned from findPeople (rcStore.recipientCache is sorted)
        return rcStore.recipientCache
            .slice(0, 100)
            .some(function (persona) {
            return persona.EmailAddresses.some(function (emailAddress) {
                return (emailAddress.OriginalDisplayName &&
                    emailAddress.OriginalDisplayName.toLowerCase() ===
                        personEmailLowerCase) ||
                    (emailAddress.EmailAddress &&
                        emailAddress.EmailAddress.toLowerCase() === personEmailLowerCase);
            });
        });
    };
    PersonaHeader.prototype.showPersonaHeaderFirstRunExperience = function () {
        if (this.toggleFavoriteDiv && this.shouldShowPersonaHeaderFirstRun()) {
            return React.createElement(PersonaHeaderFirstRun, { target: this.toggleFavoriteDiv });
        }
        return null;
    };
    PersonaHeader.prototype.getHeaderButtons = function (tableView, isPersonaFavorite) {
        var controlsContainerClassNames = classNames(styles.controlsContainer, this.props.hideCheckAll && styles.noCheckbox);
        var buttonWrapperClassName = this.props.hideCheckAll
            ? styles.wideButtonsWrapper
            : styles.buttonsWrapper;
        var buttonStyles = {
            root: styles.button,
        };
        return (React.createElement("div", { className: controlsContainerClassNames },
            !this.props.hideCheckAll && this.renderCheckAll(tableView),
            React.createElement("div", { className: buttonWrapperClassName },
                React.createElement(ActionButton, { iconProps: {
                        iconName: "Mail" /* Mail */,
                        styles: {
                            root: styles.mailIcon,
                        },
                    }, styles: buttonStyles, text: strings.emailButtonLabel, onClick: this.handleEmailClick })),
            this.props.hideFilter ? null : (React.createElement("div", { className: styles.filterWrapper },
                React.createElement(MailListFilter, { supportedViewFilters: viewFiltersForMailFolderNode, containerClassName: styles.mailFilterContainer, filterMenuSource: 'PeopleFilterMenu', tableViewId: tableView.id })))));
    };
    PersonaHeader.prototype.logHeaderRendered = function () {
        var eventName = datapoints.PersonaHeaderShown.datapoint.name;
        logUsage(eventName, [this.props.favoriteActionSource]);
    };
    PersonaHeader = tslib_1.__decorate([
        logMountingPerformance('PersonaHeader'),
        observer
    ], PersonaHeader);
    return PersonaHeader;
}(React.Component));
export default PersonaHeader;
var LPCWrapper = /** @class */ (function (_super) {
    tslib_1.__extends(LPCWrapper, _super);
    function LPCWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LPCWrapper.prototype.render = function () {
        return (React.createElement("div", { onClick: this.props.onPersonaCardBehaviorClick, onMouseEnter: this.props.onPersonaCardBehaviorMouseEnter, onMouseLeave: this.props.onPersonaCardBehaviorMouseLeave }, this.props.children));
    };
    LPCWrapper = tslib_1.__decorate([
        personaCardBehavior
    ], LPCWrapper);
    return LPCWrapper;
}(React.Component));
//# sourceMappingURL=PersonaHeader.js.map